<template>
    <footer class="footer has-cards">
        <!--
        <div class="container">
            <div class="row">
                <div class="col-md-6 mb-md-0">
                
                   <div class="card card-lift--hover shadow border-0">
                   <router-link to="/landing" title="Landing Page">
                            <img v-lazy="'img/theme/landing.jpg'" class="card-img">
                        </router-link>
                   </div>
                </div>
                <div class="col-md-6 mb-5 mb-lg-0">
                    <div class="card card-lift--hover shadow border-0">
                        <router-link to="/profile" title="Profile Page">
                            <img v-lazy="'img/theme/profile.jpg'" class="card-img">
                        </router-link>
                    </div>
                </div>
                
            </div>
        </div>
         -->
        <div class="container">
            <div class="row row-grid align-items-center my-md">

                <div class="text-center">
                            <h2 class="display-3">Đối tác</h2>
                            <div class="row justify-content-center" style="line-height: 7rem">
                                <div class="col-lg-2 col-4">

                                    <img src ="../../public/img/brand/logo-mobifone.png" class="img">

                                </div>
                                <div class="col-lg-2 col-4">

                                   <img src = "../../public/img/brand/logo-viettel.png" class="img">
                                    
                                </div>
                                <div class="col-lg-2 col-4">

                                    <img src = "../../public/img/brand/logo-vinaphone.png" class="img">
                                   
                                </div>
                                <div class="col-lg-2 col-4">

                                     <img src="../../public/img/brand/logo-vietnamobile.png" class="img">
                        
                                </div>
                            
                                 <div class="col-lg-2 col-4">

                                    <img src ="../../public/img/brand/logo-gmobile.png" class="img">
                                
                                </div>
                                <div class="col-lg-2 col-4">

                                    <img src ="../../public/img/brand/logo-evn.png" class="img">
                                
                                </div>

                                <div class="col-lg-2 col-4" >
                                     <img src="../../public/img/brand/logo-vcoin.png" class="img">
                        
                                </div>
                                
                                <div class="col-lg-2 col-4">

                                     <img src="../../public/img/brand/logo-vinagame.png" class="img">
                        
                                </div>
                                <div class="col-lg-2 col-4">

                                     <img src="../../public/img/brand/megacard.png" class="img">
                                </div>
                                <div class="col-lg-2 col-4">

                                     <img src="../../public/img/brand/logo-funtap.png" class="img">
                        
                                </div>
                                <div class="col-lg-2 col-4">
                                    
                                     <img src ="../../public/img/brand/logo-garena.png" class="img">
                                    
                                </div>
                                <div class="col-lg-2 col-4">
                                    
                                     <img src ="../../public/img/brand/logo-ongame.png" class="img">
                                    
                                </div>
                                <div class="col-lg-2 col-4">
                                    
                                     <img src ="../../public/img/brand/logo-momo.png" class="img">
                                    
                                </div>
                                <div class="col-lg-2 col-4">
                                    
                                     <img src ="../../public/img/brand/logo-whypay.png" class="img">
                                    
                                </div>
                                <div class="col-lg-2 col-4">
                                    
                                     <img src ="../../public/img/brand/logo-nganluong1.png" class="img">
                                    
                                </div>
                                <div class="col-lg-2 col-4">
                                    
                                     <img src ="../../public/img/brand/logo-baokim.png" class="img">
                                    
                                </div>
                                 <div class="col-lg-2 col-4">
                                    
                                     <img src ="../../public/img/brand/logo-VTC.png" class="img">
                                    
                                </div>
                                
                            </div>
                </div>

                <div class="col-lg-6 mb-5 mt-5">
                    <h3 class="text-primary font-weight-light mb-2">Cảm ơn bạn đã ủng hộ chúng tôi !</h3>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper mb-5 mt-5">
                    <a href="#"><img src="img/brand/octa-googleplay.png" width="125" style=" border-radius: 7px; margin-right: 15px;"/></a>
                    <a href="#"><img src="img/brand/octa-app-store.png" width="125" style=" border-radius: 7px" /></a>
                    <!--
                    <a target="_blank" href="#"
                       class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-twitter"></i>
                    </a>
                    <a target="_blank" href="#"
                       class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Like us">
                        <i class="fa fa-facebook-square"></i>
                    </a>
                    <a target="_blank" href="#"
                       class="btn btn-neutral btn-icon-only btn-dribbble btn-lg btn-round" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-dribbble"></i>
                    </a>
                    <a target="_blank" href="#"
                       class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Star on Github">
                        <i class="fa fa-github"></i>
                    </a>
                    -->
                </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between display_flex_cs">
                <div class="col-md-4">
                    <div class="copyright">
                        &copy; 2018
                        <a href="#" >Octa</a>
                    </div>
                </div>
                <div class="col-md-8">
                    <ul class="nav nav-footer justify-content-end display_block">
                        <li class="nav-item">
                            <a href="/" class="nav-link">Trang chủ</a>
                        </li>
                        <li class="nav-item">
                            <a href="#/gioi-thieu" class="nav-link">Giới Thiệu</a>
                        </li>

                        <li class="nav-item">
                            <a href="#/dieu-khoan-dich-vu" class="nav-link">Điều Khoản Dịch Vụ</a>
                        </li>

                        <li class="nav-item">
                            <a href="#/chinh-sach-bao-mat" class="nav-link">Chính Sách Bảo Mật</a>
                        </li>
                        
                        <li class="nav-item">
                            <a href="#/tin-tuc" class="nav-link">Tin Tức</a>
                        </li>
                        
                        <li class="nav-item">
                            <a href="#/tro-giup" class="nav-link">Trợ Giúp</a>
                        </li>
                        
                        <!--
                        <li class="nav-item">
                            <a href="https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md"
                               class="nav-link" target="_blank">Trợ Giúp</a>
                        </li>
                        -->
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {};
</script>
<style>
.margin {
    float: left;
    margin-right: 15px;
}
.img {
    height: 40px;
    max-width: 100%;
}

@media (max-width: 768px){
    .display_block{
        display: block!important;
    }
    .display_flex_cs{display: flex}
    .display_flex_cs > .col-md-4 {
        order:2;
        padding-left: 28px;
    }
    .display_flex_cs > .col-md-8 {
        order:1
    }
}
</style>
